import React from 'react';
import './styles/App.scss';
import { FirebaseProvider } from './providers/firebase/FirebaseProvider';
import { DataProvider } from './providers/data/DataProvider';
import { GloabalStateProvider } from './providers/globalState/GlobalStateProvider';
import StepsView from './components/steps/stepsView';
import { StaticTextProvider } from './providers/staticText/staticTextProvider';
import { BrowserRouter } from 'react-router-dom';
import { MetaPixelProvider } from './providers/metaPixel/MetaPixelProvider';
import { MixpanelProvider } from './providers/mixpanel/MixPanelProvider';
import { TikTokPixelProvider } from './providers/tiktokPixel/TikTokPixelProvider';
import { BIServiceProvider } from './providers/bi/BIServiceProvider';
import { PosthogProvider } from './providers/posthog/PosthogProvider';


function App() {


  return (
    <BrowserRouter>
      <FirebaseProvider>
        <PosthogProvider>
          <MixpanelProvider token='a2c41319d673e7b2e9ee492b6c3ab20b'>
            <MetaPixelProvider>
              <TikTokPixelProvider>
                <DataProvider>
                  <StaticTextProvider>
                    <BIServiceProvider>
                      <GloabalStateProvider>
                        <StepsView />
                      </GloabalStateProvider>
                    </BIServiceProvider>
                  </StaticTextProvider>
                </DataProvider>
              </TikTokPixelProvider>
            </MetaPixelProvider>
          </MixpanelProvider>
        </PosthogProvider>
      </FirebaseProvider>
    </BrowserRouter>
  );
}

export default App;
